<template>
    <div class="slide-show">
        <div class="slide-holder" :style="{marginLeft:-100*current+'%'}">
            <div v-for="(slide,idx) in slides" :key="idx" class="slide" :style="{backgroundImage:`url(${slide.image}?w=1920)`}">
                <div class="fader">
                    <div class="content" v-html="slide[lang]">
                    </div>
                </div>
            </div>
        </div>
        <div class="controls">
            <div class="prev-btn" @click="prev()">
                <span class="fa fa-angle-left"></span>
            </div>
            <div class="next-btn" @click="next()">
                <span class="fa fa-angle-right"></span>
            </div>
        </div>
    </div>
</template>
<script>
export default {

    name: 'slides',
    methods: {
        prev() {
            this.current = this.current - 1;
            if (this.current < 0) {
                this.current = this.slides.length - 1;
            }
            console.log("PREV", this.current);

        },
        next() {
            this.current = this.current + 1;
            if (this.current >= this.slides.length) {
                this.current = 0;
            }
            console.log("NEXT", this.current);
        },
    },
    created() {

        let self = this;
        this.$store.registerModule('slides', {
            state: {
                list: []
            },
            actions: {
                loadSlides({ state }) {
                    self.$http.get("content/slides").then((res) => {
                        state.list = res.body.slides;
                    });
                }
            }
        });

        this.$store.dispatch('loadSlides');
    },
    computed: {
        slides() { return this.$store.state.slides.list },
        lang() { return this.$store.state.lang; }
    },
    data() {
        return {
            current: 0,
            /* slides:[{
               title:"ИНСТИТУТ МИРОВОЙ<br/> ЭКОНОМИКИ И ПОЛИТИКИ",
               img:require("../assets/img/slides/1.jpg")
             },{
               title:"СОЗДАН ПРИ ФОНДЕ ПЕРВОГО <br/> ПРЕЗИДЕНТА РЕСПУБЛИКИ КАЗАХСТАН",
               img:require("../assets/img/slides/2.jpg")
             },{
               title:"ИНСТИТУТ МИРОВОЙ ЭКОНОМИКИ И ПОЛИТИКИ <br/> ОСНОВАН В 2003 ГОДУ",
               img:require("../assets/img/slides/3.jpg")
             },{
               title:"ЗАДАЧА ИМЭП: ИЗУЧЕНИЕ ПРОБЛЕМ МЕЖДУНАРОДНОЙ,<br/> РЕГИОНАЛЬНОЙ И НАЦИОНАЛЬНОЙ БЕЗОПАСНОСТИ",
               img:require("../assets/img/slides/4.jpg")
             },{
               title:"МЕЖДУНАРОДНО-ПОЛИТИЧЕСКИЕ ИССЛЕДОВАНИЯ",
               img:require("../assets/img/slides/5.jpg")
             },{
               title:"СОДЕЙСТВИЕ МЕЖДУНАРОДНОМУ <br/>СОТРУДНИЧЕСТВУ, МИРУ И СТАБИЛЬНОСТИ",
               img:require("../assets/img/slides/6.jpg")
             },{
               title:"МЕЖДУНАРОДНО-ПОЛИТИЧЕСКИЕ ИССЛЕДОВАНИЯ",
               img:require("../assets/img/slides/7.jpg")
             },{
               title:"ГЛОБАЛЬНЫЕ ПРОБЛЕМЫ СОВРЕМЕННОСТИ<br/> И ИХ ВЛИЯНИЕ НА КАЗАХСТАН",
               img:require("../assets/img/slides/8.jpg")
             }]*/
        }
    }
}
</script>
<style lang="css" scoped>
.slide-show {
    height: 520px;
    overflow: hidden;
}

.slide {
    /*background: url(./img/building/2.webp);*/
    /*background: url(./img/building/1.jpg);*/
    background-size: cover;
    height: 520px;
    background-position: center;
    width: 12.5%;
    float: left;
}

.slide-holder {
    white-space: nowrap;
    width: 800%;
    transition: 0.3s all ease;
}

.next-btn,
.prev-btn {
    padding: 16px 16px;
    font-size: 24px;
    color: grey;
    display: inline-block;
    cursor: pointer;
    margin-top: 220px;
    z-index: 8;
}

.next-btn:hover,
.prev-btn:hover {
    background: rgba(0, 0, 0, 0.2);



}

.next-btn {
    float: right;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
}

.prev-btn {
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;

}

.controls {
    height: 400px;
    position: relative;
    display: block;
    width: 100%;
    top: -100%;
    z-index: 9;
}

.fader {
    height: 400px;
    background: rgba(0, 0, 0, 0.25);
    display: table;
    width: 100%;
    transition: 0.3s all ease;
}

.slide .content {
    vertical-align: middle;
    text-align: center;
    font-size: 42px;
    color: white;
    height: 520px;
    display: table-cell;
    width: 100%;
    white-space: normal;
    padding: 0 15%;
    text-transform: uppercase;
    font-weight: bold;
}

.slide-show:hover .fader {
    /*background: rgba(0,0,0,0.75);*/
}

@media(max-width:740px) {
    .slide .content {
        font-size: 34px;
        padding: 10%;
    }
}
</style>